import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './departments.loaders';
import { departmentsKeys } from './departments.queries';

export const useCreateDepartment = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createDepartment, {
    onSuccess: () => {
      return queryClient.invalidateQueries(departmentsKeys.all);
    },
  });
};

export const useUpdateDepartment = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateDepartment, {
    onSuccess: () => {
      return queryClient.invalidateQueries(departmentsKeys.all);
    },
  });
};

export const useDeleteDepartment = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteDepartment, {
    onSuccess: () => {
      return queryClient.invalidateQueries(departmentsKeys.all);
    },
  });
};
